import {
  GatsbyImage,
  GatsbyImageProps,
  IGatsbyImageData,
} from 'gatsby-plugin-image'
import { memo } from 'react'
import styled from 'styled-components'
import { DeepNullable } from '../../utilities'

const CustomImage = styled(GatsbyImage)`
  & img {
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-user-drag: none;
    -webkit-touch-callout: none;
  }
`

export type StrapiImageData = null | DeepNullable<{
  localFile: {
    childImageSharp: {
      gatsbyImageData: IGatsbyImageData
    }
  }
}>

type StrapiImagePropType = Partial<Omit<GatsbyImageProps, 'image'>> & {
  strapiImage?: StrapiImageData
  isRequired?: boolean
}

export const StrapiImage = memo<StrapiImagePropType>(
  ({ strapiImage, alt = '', className, isRequired = false, ...others }) => {
    if (strapiImage?.localFile?.childImageSharp?.gatsbyImageData) {
      return (
        <CustomImage
          className={className}
          image={strapiImage?.localFile?.childImageSharp?.gatsbyImageData}
          alt={alt}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...others}
        />
      )
    }
    if (isRequired) {
      console.error(strapiImage, JSON.stringify(strapiImage, null, 2))
      throw new Error('Required image is missing: ')
    }
    return null
  },
)
StrapiImage.displayName = 'StrapiImage'
